"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _trim2 = _interopRequireDefault(require("lodash/trim"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
function contactPayloadFactory(contact) {
  var dialCode = contact === null || contact === void 0 ? void 0 : contact.dialCode;
  var firstName = contact === null || contact === void 0 ? void 0 : contact.firstName;
  var lastName = contact === null || contact === void 0 ? void 0 : contact.lastName;
  return {
    title: contact === null || contact === void 0 ? void 0 : contact.title,
    firstName: firstName,
    lastName: (0, _isEmpty2.default)(lastName) ? firstName : lastName,
    email: (0, _trim2.default)(contact === null || contact === void 0 ? void 0 : contact.email),
    phone: dialCode + (contact === null || contact === void 0 ? void 0 : contact.phone),
    dialCode: dialCode
  };
}
var _default = exports.default = contactPayloadFactory;